/**
 * The MYLE employee type.
 *
 * This is considered the MYLE user role.
 */
enum EmployeeType {
    None = 0,

    /** An assistant (clerical) user. */
    Assistant = 1,

    /** A practician (clinical) user. */
    Practician = 2,

    /** An admin user. */
    Admin = 4,

    /** An API user. */
    Api = 8
}

export { EmployeeType };
